import Http from "./Http";

export class ContentRequestService extends Http {
  /**
     * Get a list of users who can be proposed
     * @param {string} username

     */
  getContentRequestMockData(username) {
    return this.get(`/request-content-form/${username}`);
  }

  /**
   * Make a purchase throw CCBill
   * @param {string} username
   * @param {object} body
   */
  purchaseThrowCCBill({ username, body }) {
    return this.post(`/request-content-form/${username}/payments`, body);
  }
}

export default new ContentRequestService();
